// src/components/common/EmptyStateGuide.js
import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, BarChart3 } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import './EmptyStateGuide.css';

export const EmptyStateGuide = () => {
  const { translate } = useLanguage();

  return (
    <div className="empty-state-container">
      <motion.div
        className="empty-state-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        {/* Animated Icon Badge */}
        <motion.div
          className="empty-state-badge"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.1, duration: 0.5, ease: "easeOut" }}
        >
          <motion.div
            className="icon-wrapper"
            animate={{ y: [0, -4, 0] }}
            transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
          >
            <BarChart3 size={32} strokeWidth={1.5} />
          </motion.div>
        </motion.div>

        {/* Title */}
        <motion.h2
          className="empty-state-title"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.4 }}
        >
          {translate('trendPage.emptyState.title')}
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          className="empty-state-subtitle"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.4 }}
        >
          {translate('trendPage.emptyState.subtitle')}
        </motion.p>

        {/* Hint */}
        <motion.div
          className="empty-state-hint"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.4 }}
        >
          <Lightbulb size={14} />
          <span>{translate('trendPage.emptyState.hint')}</span>
        </motion.div>
      </motion.div>
    </div>
  );
};
